import { css } from '@emotion/css';

export const datePickerOverrideStyles = css`
  > div {
    height: unset;
    width: 100% !important;
    padding-inline-start: 1rem;
    padding-inline-end: 1rem;
  }

  div {
    font-weight: var(--fw-heading-xs);
    font-size: var(--text-16);
    line-height: var(--lh-24);
  }

  .MuiTypography-caption,
  .MuiPickersDay-root {
    font-weight: var(--fw-body-short-02);
    font-size: var(--text-14);
    line-height: var(--lh-22);
    color: var(--text-primary);
    font-family: var(--font-primary);
  }

  .MuiTypography-caption {
    color: var(--text-placeholder);
    font-size: 1.4rem;
  }

  .Mui-selected {
    background-color: var(--interactive-primary);
    font-weight: var(--fw-heading-xxs);
    line-height: var(--lh-18);
    color: var(--text-white);
  }

  .MuiPickersDay-today:not(.Mui-selected) {
    border: 1px solid var(--interactive-primary);
    background: inherit;
    color: var(--text-primary);
    font-weight: var(--fw-body-short-02);
  }

  .MuiPickersDay-root.Mui-focusVisible {
    outline: 0.16rem solid transparent;
    box-shadow: 0 0 0 0.16rem var(--interactive-white), 0 0 0 0.32rem var(--focus-secondary);
  }

  .MuiPickersCalendarHeader-root {
    margin-top: 0px;
    padding: 0px 0px 6px 8px;
  }

  .MuiPickersArrowSwitcher-button {
    &:hover {
      background: var(--bg-primary);
    }
    &.Mui-focusVisible {
      outline: 0.16rem solid transparent;
      box-shadow: 0 0 0 0.16rem var(--interactive-white), 0 0 0 0.32rem var(--focus-secondary);
    }
  }

  .MuiDayPicker-slideTransition {
    min-height: unset;
  }

  .Mui-disabled {
    color: var(--text-placeholder);
  }
`;
